import RequestForm from "./request-form"
import Collection from "../../data-structures/collection"
import {loadRequestFormsCollectionMissingData} from "./functions/load-collection-missing-data";

export default class RequestFormsCollection extends Collection<RequestForm> {

    constructor(models:any) {
        super(models)
    }

    static async initFromJson(requestFormsData:JSONArray):Promise<RequestFormsCollection> {
        await loadRequestFormsCollectionMissingData(requestFormsData)

        const models:RequestForm[] = _(requestFormsData)
            .map((requestFormData)=>new RequestForm(requestFormData))
            .orderBy(model=>model.sortPosition)
            .value()

        return new RequestFormsCollection(models)
    }

    // used when we want to store sort position within collection itself
    // i.e. manual sorting without sortPosition field
    reorderByIds(orderedIds: ID[]):void {
        const result:any[] = []
        _.map(orderedIds, (id, key)=>{
            const model = this.get(id)
            if (model) {
                result.push(model)
                model.sortPosition = key
            }
        })
        this.models = result
    }

    // Delta
    applyDelta(method: string, data:any) {

        switch (method) {
            case 'delete'   :
                this.remove(data.id)
                break

            case 'new'      :
                if (!this.get(data.id)) this.add(new RequestForm(data))
                break

            case 'delta'    :
                const model: RequestForm | null = this.get(data.id)
                if (model) {
                    model.applyDelta(data)
                }
                break
        }
    }

    toOptions():Option[] {
        return _.map(this.models, (model)=>{
            return model.toOption()
        })
    }
}